import { render } from "./PromptEditor.vue?vue&type=template&id=7b21ff02&scoped=true"
import script from "./PromptEditor.vue?vue&type=script&lang=js"
export * from "./PromptEditor.vue?vue&type=script&lang=js"

import "./PromptEditor.vue?vue&type=style&index=0&id=7b21ff02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b21ff02"]])

export default __exports__